const productsCategoriesAndSubcategories = [
    {   
        slug:"moda-para-mujer",
        name:"Moda para mujer",
        subcategories:[ 
            {slug:"vestidos",name:"Vestidos"},
            {slug:"camisetas",name:"Camisetas"},
            {slug:"blusas-y-camisas",name:"Blusas y camisas"},
            {slug:"sudaderas",name:"Sudaderas"},
            {slug:"conjuntos-de-mujer",name:"Conjuntos de mujer"},
            {slug:"trajes-y-blazers",name:"Trajes y blazers"},
            {slug:"bodies",name:"Bodies"},
            {slug:"tops-y-camisetas-de-tirantes",name:"Tops y camisetas de tirantes"},
            {slug:"abrigos-y-chaquetas",name:"Abrigos y chaqueta"},
            {slug:"suetees",name:"Suéteres"},
            {slug:"conjuntos-de-bikinis",name:"Conjuntos de bikinis"},
            {slug:"vestidos-de-playa",name:"Vestidos de playa"},
            {slug:"leggings",name:"Leggings"},
            {slug:"faldas",name:"Faldas"},
            {slug:"shorts-y-pantalones-cortos",name:"Shorts y pantalones cortos"},
            {slug:"vaqueros",name:"Vaqueros"},
            {slug:"pantalones-y-capris",name:"Pantalones y capris"},
            {slug:"bodas-y-celebraciones",name:"Bodas y celebraciones"},
            {slug:"vestidos-de-novia",name:"Vestidos de novia"},
            {slug:"vestidos-de-gala",name:"Vestidos de gala"},
            {slug:"Vestidos-de-noche",name:"Vestidos de noche"},
            {slug:"ropa-africana",name:"Ropa africana"},
            {slug:"disfraces",name:"Disfraces"},
            {slug:"lenceria-y-ropa-interior-de-mujer",name:"Lencería y ropa interior de mujer"},
            {slug:"conjuntos-de-pijama",name:"Conjuntos de pijama"},
            {slug:"sujetadores",name:"Sujetadores"},
            {slug:"bragas",name:"Bragas"},
            {slug:"calcetines",name:"Calcetines"},
            {slug:"sujetadores-y-bragas",name:"Sujetadores y bragas"},
            {slug:"prendas-moldeadoras",name:"Prendas moldeadoras"},
            {slug:"complementos",name:"Complementos"},
            {slug:"complementos-para-el-pelo",name:"Complementos para el pelo"},
            {slug:"gafas-de-sol",name:"Gafas de sol"},
            {slug:"gafas-con-filtro-de-luz-azul",name:"Gafas con filtro de luz azul"},
            {slug:"Gorras-de-beisbol",name:"Gorras de béisbol"},
            {slug:"sombreros-de-pesca",name:"Sombreros de pesca"},
            {slug:"cinturones",name:"Cinturones"},
            {slug:"moda-de-mujer-en-general",name:"Moda de mujer en general"},
        ]
    },
    {
        slug:"moda-para-hombre",
        name:"Moda para hombre",
        subcategories:[
            {slug:"sudaderas",name:"Sudaderas"},
            {slug:"camisetas",name:"Camisetas"},
            {slug:"camisas",name:"Camisas"},
            {slug:"pantalones-cortos",name:"Pantalones cortos"},
            {slug:"conjuntos-de-hombre",name:"Conjuntos de hombre"},
            {slug:"chaquetas",name:"Chaquetas"},
            {slug:"pantalones",name:"Pantalones"},
            {slug:"pantalones-informales",name:"Pantalones informales"},
            {slug:"pantalones-deportivos",name:"Pantalones deportivos"},
            {slug:"pantalones-cargo",name:"Pantalones cargo"},
            {slug:"vaqueros",name:"Vaqueros"},
            {slug:"pantalones-anchos",name:"Pantalones anchos"},
            {slug:"pantalone-scortos",name:"Pantalones cortos"},
            {slug:"chaquetas",name:"Chaquetas"},
            {slug:"sueteres",name:"Suéteres"},
            {slug:"imitacion-de-cuero",name:"Imitación de cuero"},
            {slug:"chaquetas-de-cuero",name:"Chaquetas de cuero"},
            {slug:"parkas",name:"Parkas"},
            {slug:"chaquetas-de-plumas",name:"Chaquetas de plumas"},
            {slug:"trajes-y-blazers",name:"Trajes y blazers"},
            {slug:"ropa-interior-y-homewear",name:"Ropa interior y homewear"},
            {slug:"boxers",name:"Boxers"},
            {slug:"slips",name:"Slips"},
            {slug:"calzoncillos-largos",name:"Calzoncillos largos"},
            {slug:"pijamas-y-homewear",name:"Pijamas y homewear"},
            {slug:"conjuntos-de-pijama",name:"Conjuntos de pijama"},
            {slug:"bufandas",name:"Bufandas"},
            {slug:"gorros",name:"Gorros"},
            {slug:"gafas-graduadas",name:"Gafas graduadas"},
            {slug:"guantes-y-mitones",name:"Guantes y mitones"},
            {slug:"cinturones",name:"Cinturones"},
            {slug:"gorros-de-aviador",name:"Gorros de aviador"},
            {slug:"sombreros-fedora",name:"Sombreros fedora"},
            {slug:"boinas",name:"Boinas"},
            {slug:"gorras",name:"Gorras"},
            {slug:"ocasiones-especiales",name:"Ocasiones especiales"},
            {slug:"disfraces",name:"Disfraces"},
            {slug:"popa-de-baile-y-escenario",name:"Ropa de baile y escenario"},
            {slug:"ropa-exotica",name:"Ropa exótica"},
            {slug:"moda-para-hombre-en-general",name:"Moda para hombre en general"},
        ]
    },
    {
        slug:"moda-para-bebes",
        name:"Moda para Bebés",
        subcategories:[
            {slug:"actividad-y-entretenimiento",name:"Actividad y entretenimiento"},
            {slug:"vestimenta-y-accesorios",name:"Vestimenta y accesorios"},
            {slug:"juguetes-para-bebes-y-ninos-pequenos",name:"Juguetes para bebés y niños pequeños"},
            {slug:"cuidado-de-bebes",name:"Cuidado de bebés"},
            {slug:"articulos-de-papeleria-para-bebes",name:"Artículos de papelería para bebés"},
            {slug:"asientos-para-auto-y-accesorios",name:"Asientos para auto y accesorios"},
            {slug:"panales",name:"Pañales"},
            {slug:"alimentacion",name:"Alimentación"},
            {slug:"regalos",name:"Regalos"},
            {slug:"habitación-de-bebe",name:"Habitación de bebé"},
            {slug:"entrenamiento-de-bano",name:"Entrenamiento de baño"},
            {slug:"embarazo-y-maternidad",name:"Embarazo y maternidad"},
            {slug:"seguridad",name:"Seguridad"},
            {slug:"cochecitos-y-accesorios",name:"Cochecitos y accesorios"},
            {slug:"articulos-para-viajes",name:"Artículos para viajes"},
            {slug:"accesorios-para-bebes-en-general",name:"Accesorios para Bebes en general"},
        ]
    },
    {
        slug:"telefonia-y-comunicaciones",
        name:"Telefonía y comunicaciones",
        subcategories:[
            {slug:"celulares-android",name:"Celulares Android"},
            {slug:"iPhones",name:"iPhones"},
            {slug:"smartphones-recomendados",name:"Smartphones recomendados"},
            {slug:"smartphones-reacondicionados",name:"Smartphones reacondicionados"},
            {slug:"smartphones-con-5G",name:"Smartphones con 5G"},
            {slug:"realme",name:"realme"},
            {slug:"onePlus",name:"OnePlus"},
            {slug:"huawei",name:"HUAWEI"},
            {slug:"infinix",name:"infinix"},
            {slug:"poco",name:"POCO"},
            {slug:"fundas",name:"Fundas"},
            {slug:"cables",name:"Cables"},
            {slug:"cargadores",name:"Cargadores"},
            {slug:"bateria-portatil",name:"Batería portátil"},
            {slug:"soportes",name:"Soportes"},
            {slug:"protectores-de-pantalla",name:"Protectores de pantalla"},
            {slug:"fundas-para-iPhone",name:"Fundas para iPhone"},
            {slug:"fundas-para-samsung",name:"Fundas para Samsung"},
            {slug:"fundas-para-huawei",name:"Fundas para Huawei"},
            {slug:"fundas-para-xiaomi",name:"Fundas para Xiaomi"},
            {slug:"fundas-para-meizu",name:"Fundas para Meizu"},
            {slug:"fundas-para-oppo",name:"Fundas para OPPO"},
            {slug:"cargadores-inalambricos",name:"Cargadores inalámbricos"},
            {slug:"cargadores-para-coche",name:"Cargadores para coche"},
            {slug:"objetivos",name:"Objetivos"},
            {slug:"adaptadores",name:"Adaptadores"},
            {slug:"lcd-para-moviles",name:"LCD para móviles"},
            {slug:"baterias-para-celulares",name:"Baterías para celulares"},
            {slug:"carcasas",name:"Carcasas"},
            {slug:"walkie-talkie",name:"Walkie Talkie"},
            {slug:"equipos-de-fibra-optica",name:"Equipos de fibra óptica"},
            {slug:"antenas-de-comunicacion",name:"Antenas de comunicación"},
            {slug:"accesorios-para-laptop",name:"Accesorios para Laptop"},
            {slug:"accesorios-para-computadora",name:"Accesorios para Computadora"},
            {slug:"accesorios-para-tablet",name:"Accesorios para Tablet"},
            {slug:"accesorios-para-celulares",name:"Accesorios para Celulares"},
            {slug:"accesorios-para-celulares-en-general",name:"Accesorios para celulares en general"},
        ]
    },
    {   slug:"informatica-oficina-y-seguridad",
        name:"Informática, oficina y seguridad",
        subcategories:[
            {slug:"componentes-y-perifericos",name:"Componentes y periféricos"},
            {slug:"procesadores",name:"Procesadores"},
            {slug:"placas-base",name:"Placas base"},
            {slug:"tarjetas-graficas",name:"Tarjetas gráficas"},
            {slug:"ratones",name:"Ratones"},
            {slug:"teclados",name:"Teclados"},
            {slug:"portátiles",name:"Portátiles"},
            {slug:"portatiles-par-gaming",name:"Portátiles para gaming"},
            {slug:"portatiles-ultrafinos",name:"Portátiles ultrafinos"},
            {slug:"tablets",name:"Tablets"},
            {slug:"accesorios-para-portátiles",name:"Accesorios para portátiles"},
            {slug:"accesorios-para-tablets",name:"Accesorios para tablets"},
            {slug:"fundas-y-maletines-para-portátiles",name:"Fundas y maletines para portátiles"},
            {slug:"feguridad-y-proteccion",name:"Seguridad y protección"},
            {slug:"vigilancia",name:"Vigilancia"},
            {slug:"cocontrol-de-accesos",name:"Control de accesos"},
            {slug:"cetectores-de-humo",name:"Detectores de humo"},
            {slug:"equipos-de-proteccion y seguridad",name:"Equipos de protección y seguridad"},
            {slug:"alarmas-y-sensores",name:"Alarmas y sensores"},
            {slug:"interfonos",name:"Interfonos"},
            {slug:"dispositivos-de-almacenamiento",name:"Dispositivos de almacenamiento"},
            {slug:"memorias-usb",name:"Memorias USB"},
            {slug:"tarjetas-de-memoria",name:"Tarjetas de memoria"},
            {slug:"discos-duros-externos",name:"Discos duros externos"},
            {slug:"carcasas-para-discos-duros",name:"Carcasas para discos duros"},
            {slug:"ssd",name:"SSD"},
            {slug:"electronica-de-oficina",name:"Electrónica de oficina"},
            {slug:"impresoras-3d",name:"Impresoras 3D"},
            {slug:"accesorios-y-piezas-para-impresoras-3d",name:"Accesorios y piezas para impresoras 3D"},
            {slug:"impresoras",name:"Impresoras"},
            {slug:"piezas-de-impresoras",name:"Piezas de impresoras"},
            {slug:"escaneres",name:"Escáneres"},
            {slug:"cartuchos-de-tinta",name:"Cartuchos de tinta"},
            {slug:"material-de-impresion-3d",name:"Material de impresión 3D"},
            {slug:"redes",name:"Redes"},
            {slug:"routers-inalambricos",name:"Routers inalámbricos"},
            {slug:"tarjetas-de-red",name:"Tarjetas de red"},
            {slug:"modems-3g",name:"Módems 3G"},
            {slug:"packs-modem-router",name:"Packs módem/router"},
            {slug:"herramientas-de-redes",name:"Herramientas de redes"},
            {slug:"computadoras-en-general",name:"Computadoras en general"},

        ]
    },
    {   slug:"electronica",
        name:"Electrónica",
        subcategories:[
            {slug:"piezas-y-accesorios",name:"Piezas y accesorios"},
            {slug:"cables-y-adaptadores",name:"Cables y adaptadores"},
            {slug:"cigarrillos-electronicos",name:"Cigarrillos electrónicos"},
            {slug:"pilas",name:"Pilas"},
            {slug:"cargadores",name:"Cargadores"},
            {slug:"electronica-para-casa",name:"Electrónica para casa"},
            {slug:"bolsas-y-fundas",name:"Bolsas y fundas"},
            {slug:"audio-y-vídeo-en-casa",name:"Audio y vídeo en casa"},
            {slug:"televisores",name:"Televisores"},
            {slug:"receptores-de-television",name:"Receptores de televisión"},
            {slug:"proyectores",name:"Proyectores"},
            {slug:"amplificadores-de-audio",name:"Amplificadores de audio"},
            {slug:"sticks-tv",name:"Sticks TV"},
            {slug:"camaras-y-fotografía",name:"Cámaras y fotografía"},
            {slug:"camaras-digitales",name:"Cámaras digitales"},
            {slug:"camaras-de-vídeo",name:"Cámaras de vídeo"},
            {slug:"daones-con-cámara",name:"Drones con cámara"},
            {slug:"camaras-de-acción",name:"Cámaras de acción"},
            {slug:"estudios-de-fotografía",name:"Estudios de fotografía"},
            {slug:"camaras-y-accesorios",name:"Cámaras y accesorios"},
            {slug:"audio-y-video-portátil",name:"Audio y vídeo portátil"},
            {slug:"auriculares-y-cascos",name:"Auriculares y cascos"},
            {slug:"altavoces",name:"Altavoces"},
            {slug:"reproductores-mp3",name:"Reproductores MP3"},
            {slug:"microfonos",name:"Micrófonos"},
            {slug:"dispositivos-rv-y-ar",name:"Dispositivos RV y AR"},
            {slug:"electronica-inteligente",name:"Electrónica inteligente"},
            {slug:"dispositivos-inteligentes",name:"Dispositivos inteligentes"},
            {slug:"electrodomesticos-inteligentes",name:"Electrodomésticos inteligentes"},
            {slug:"accesorios-para-dispositivos-inteligentes",name:"Accesorios para dispositivos inteligentes"},
            {slug:"mandos-a-distancia",name:"Mandos a distancia"},
            {slug:"smartwatches",name:"Smartwatches"},
            {slug:"smartbands",name:"Smartbands"},
            {slug:"videojuegos",name:"Videojuegos"},
            {slug:"videoconsolas",name:"Videoconsolas"},
            {slug:"gamepads",name:"Gamepads"},
            {slug:"joysticks",name:"Joysticks"},
            {slug:"pegatinas",name:"Pegatinas"},
            {slug:"electronica-en-general",name:"Electronica en general"},
            
        ]
    },
    {
        name:"Bisutería y relojes",
        slug:"bisuteria-y-relojes",
        subcategories:[
            {slug:"joyeria-fina",name:"Joyería fina"},
            {slug:"joyas-de-plata-925",name:"Joyas de plata 925"},
            {slug:"joyas-de-diamantes",name:"Joyas de diamantes"},
            {slug:"joyeria-de-perlas",name:"Joyería de perlas"},
            {slug:"joyería-con-gemas",name:"Joyería con gemas"},
            {slug:"joyas-de-oro",name:"Joyas de oro"},
            {slug:"pendientes",name:"Pendientes"},
            {slug:"conjuntos-de-joyeria-fina",name:"Conjuntos de joyería fina"},
            {slug:"joyería-fina-de-hombre",name:"Joyería fina de hombre"},
            {slug:"bodas-y-compromiso",name:"Bodas y compromiso"},
            {slug:"joyeria-para-novias",name:"Joyería para novias"},
            {slug:"anillos-de-compromiso",name:"Anillos de compromiso"},
            {slug:"accesorios-para-el-pelo",name:"Accesorios para el pelo"},
            {slug:"relojes-de-hombre",name:"Relojes de hombre"},
            {slug:"relojes-mecanicos",name:"Relojes mecánicos"},
            {slug:"relojes-de-cuarzo",name:"Relojes de cuarzo"},
            {slug:"relojes-digitales",name:"Relojes digitales"},
            {slug:"relojes-de-doble-pantalla",name:"Relojes de doble pantalla"},
            {slug:"relojes-deportivos",name:"Relojes deportivos"},
            {slug:"relojes-de-mujer",name:"Relojes de mujer"},
            {slug:"relojes-de-pulsera-para-mujer",name:"Relojes de pulsera para mujer"},
            {slug:"relojes-elegantes",name:"Relojes elegantes"},
            {slug:"relojes-de-pareja",name:"Relojes de pareja"},
            {slug:"relojes-deportivos",name:"Relojes deportivos"},
            {slug:"relojes-originales",name:"Relojes originales"},
            {slug:"bisuteria",name:"Bisutería"},
            {slug:"collares-y-colgantes",name:"Collares y colgantes"},
            {slug:"tendencias-en-anillos",name:"Tendencias en anillos"},
            {slug:"tendencias-en-pendientes",name:"Tendencias en pendientes"},
            {slug:"pulseras-y-brazaletes",name:"Pulseras y brazaletes"},
            {slug:"gemelos",name:"Gemelos"},
            {slug:"conjuntos-de-bisutería",name:"Conjuntos de bisutería"},
            {slug:"amuletos",name:"Amuletos"},
            {slug:"bisuteria-para-el-cuerpo",name:"Bisutería para el cuerpo"},
            {slug:"cuentas-y-bisuteria-artesanal",name:"Cuentas y bisutería artesanal"},
            {slug:"cuentas",name:"Cuentas"},
            {slug:"bisuteria-y-componentes",name:"Bisutería y componentes"},
            {slug:"packaging-y-presentacion-de-joyas",name:"Packaging y presentación de joyas"},
            {slug:"Bisutería-y-relojes-en-genearal",name:"Bisutería y relojes en general"},
        ]
    },
    {   
        slug:"hogar-mascotas-y-electrodomesticos",
        name:"Hogar, mascotas y electrodomésticos",
        subcategories:[
            {slug:"arte",name:"Arte"},
            {slug:"scrapbooking",name:"Scrapbooking"},
            {slug:"costura",name:"Costura"},
            {slug:"punto-y-artesania",name:"Punto y artesanía"},
            {slug:"pintura-diamante-5d",name:"Pintura diamante 5D"},
            {slug:"productos-para-mascotas",name:"Productos para mascotas"},
            {slug:"collares-para-perro",name:"Collares para perro"},
            {slug:"juguetes",name:"Juguetes"},
            {slug:"acuarios-y-tanques",name:"Acuarios y tanques"},
            {slug:"textil-para-el-hogar",name:"Textil para el hogar"},
            {slug:"cojines",name:"Cojines"},
            {slug:"cortinas",name:"Cortinas"},
            {slug:"ropa-de-cama",name:"Ropa de cama"},
            {slug:"toallas-de-playa",name:"Toallas de playa"},
            {slug:"celebraciones",name:"Celebraciones"},
            {slug:"eventos-y-fiestas",name:"Eventos y fiestas"},
            {slug:"flores-artificiales-y-secas",name:"Flores artificiales y secas"},
            {slug:"cajas-y-bolsas-de-regalo",name:"Cajas y bolsas de regalo"},
            {slug:"artículos-del-hogar",name:"Artículos del hogar"},
            {slug:"paraguas",name:"Paraguas"},
            {slug:"básculas-de-baño",name:"Básculas de baño"},
            {slug:"escobas-y-mopas",name:"Escobas y mopas"},
            {slug:"almacenamiento-en-casa",name:"Almacenamiento en casa"},
            {slug:"almacenamiento-y-basura",name:"Almacenamiento y basura"},
            {slug:"cestos-para-la-colada",name:"Cestos para la colada"},
            {slug:"organizadores-para-maquillaje",name:"Organizadores para maquillaje"},
            {slug:"mobiliario",name:"Mobiliario"},
            {slug:"muebles-de-oficina",name:"Muebles de oficina"},
            {slug:"muebles-para-el-hogar",name:"Muebles para el hogar"},
            {slug:"cocina",name:"Cocina"},
            {slug:"utensilios-para-hornear",name:"Utensilios para hornear"},
            {slug:"vasos-copas-y-tazas",name:"Vasos, copas y tazas"},
            {slug:"utensilios-de-cocina",name:"Utensilios de cocina"},
            {slug:"cuchillos-y-accesorios-de-cocina",name:"Cuchillos y accesorios de cocina"},
            {slug:"decoracion-del-hogar",name:"Decoración del hogar"},
            {slug:"pintura-y-caligrafia",name:"Pintura y caligrafía"},
            {slug:"pegatinas-de-pared",name:"Pegatinas de pared"},
            {slug:"figuras-y-miniaturas",name:"Figuras y miniaturas"},
            {slug:"relojes-de-pared",name:"Relojes de pared"},
            {slug:"jardineria",name:"Jardinería"},
            {slug:"riego",name:"Riego"},
            {slug:"macetas-y-jardineras",name:"Macetas y jardineras"},
            {slug:"repelentes",name:"Repelentes"},
            {slug:"muebles-de-exterior",name:"Muebles de exterior"},
            {slug:"comida-para-perros",name:"Comida para perros"},
            {slug:"hogar-en-general",name:"Hogar en general"},
            {slug:"mascotas-en-general",name:"Mascotas en general"},
            {slug:"electrodomesticos-en-general",name:"Electrodomesticos en general"},
        ]
    },
    {
        slug:"bolsos-y-calzados",
        name:"Bolsos y calzado",
        subcategories:[
            {slug:"maletas-y-bolsos-de-mujer",name:"Maletas y bolsos de mujer"},
            {slug:"mochilas-modernas",name:"Mochilas modernas"},
            {slug:"bolsos-de-tela",name:"Bolsos de tela"},
            {slug:"bolsos-de-hombro",name:"Bolsos de hombro"},
            {slug:"carteras",name:"Carteras"},
            {slug:"bolsos-de-fiesta",name:"Bolsos de fiesta"},
            {slug:"clutches-y-carteras",name:"Clutches y carteras"},
            {slug:"calzado-de-mujer",name:"Calzado de mujer"},
            {slug:"sandalias-de-mujer",name:"Sandalias de mujer"},
            {slug:"zapatos-planos",name:"Zapatos planos"},
            {slug:"zapatos-de-tacon",name:"Zapatos de tacón"},
            {slug:"zapatillas-vulcanizadas",name:"Zapatillas vulcanizadas"},
            {slug:"zapatillas-de-estar-por-casa",name:"Zapatillas de estar por casa"},
            {slug:"botas",name:"Botas"},
            {slug:"maletas-y-bolsos-de-hombre",name:"Maletas y bolsos de hombre"},
            {slug:"mochilas-de-hombre",name:"Mochilas de hombre"},
            {slug:"bandoleras",name:"Bandoleras"},
            {slug:"maletines",name:"Maletines"},
            {slug:"maletas-y-bolsas-de-viaje",name:"Maletas y bolsas de viaje"},
            {slug:"carteras",name:"Carteras"},
            {slug:"calzado-de-hombre",name:"Calzado de hombre"},
            {slug:"calzado-casual",name:"Calzado casual"},
            {slug:"zapatillas-vulcanizadas",name:"Zapatillas vulcanizadas"},
            {slug:"sandalias-de-hombre",name:"Sandalias de hombre"},
            {slug:"mocasines",name:"Mocasines"},
            {slug:"chanclas",name:"Chanclas"},
            {slug:"botas",name:"Botas"},
            {slug:"bolsos-y-complementos",name:"bolsos y complementos"},
            {slug:"bolsos-infantiles",name:"Bolsos infantiles"},
            {slug:"estuches-de-maquillaje",name:"Estuches de maquillaje"},
            {slug:"monederos-y-tarjeteros",name:"Monederos y tarjeteros"},
            {slug:"cubiertas-para-maletas",name:"Cubiertas para maletas"},
            {slug:"fundas-para-pasaporte",name:"Fundas para pasaporte"},
            {slug:"accesorios-y-piezas-para-bolsos",name:"Accesorios y piezas para bolsos"},
            {slug:"calzado-superventas",name:"Calzado superventas"},
            {slug:"sandalias-de-cuña",name:"Sandalias de cuña"},
            {slug:"tacones-clasicos",name:"Tacones clásicos"},
            {slug:"calzado-de-tallas-grandes",name:"Calzado de tallas grandes"},
            {slug:"zapatillas-de-estar-por-casa",name:"Zapatillas de estar por casa"},
            {slug:"zapatillas-de-moda",name:"Zapatillas de moda"},
            {slug:"sandalias-comodas",name:"Sandalias cómodas"},
        ]
    },
    { 
        slug:"juguetes-e-infantil",
        name:"Juguetes e infantil",
        subcategories:[
            {slug:"categorias-populares",name:"Categorías populares"},
            {slug:"vestidos",name:"Vestidos"},
            {slug:"conjuntos",name:"Conjuntos"},
            {slug:"conjuntos-para-la-familia",name:"Conjuntos para la familia"},
            {slug:"sudaderas",name:"Sudaderas"},
            {slug:"pijamas-y-batas",name:"Pijamas y batas"},
            {slug:"calzado-infantil",name:"Calzado infantil"},
            {slug:"cochecitos",name:"Cochecitos"},
            {slug:"bebe-0-3-anos",name:"Bebé (0-3 años)"},
            {slug:"bodis",name:"Bodis"},
            {slug:"conjunto-de-bebe",name:"Conjunto de bebé"},
            {slug:"patucos",name:"Patucos"},
            {slug:"complementos-para-bebe",name:"Complementos para bebé"},
            {slug:"cambiadores",name:"Cambiadores"},
            {slug:"alimentacion",name:"Alimentación"},
            {slug:"sábanas-infantiles",name:"Sábanas infantiles"},
            {slug:"mordedores",name:"Mordedores"},
            {slug:"juguetes-para-bebe",name:"Juguetes para bebé"},
            {slug:"para-ninas",name:"Para niñas"},
            {slug:"vestidos",name:"Vestidos"},
            {slug:"conjuntos",name:"Conjuntos"},
            {slug:"tops-y-camisetas",name:"Tops y camisetas"},
            {slug:"chaquetas-y-abrigos",name:"Chaquetas y abrigos"},
            {slug:"pijamas-y-batas",name:"Pijamas y batas"},
            {slug:"para-ninos",name:"Para niños"},
            {slug:"conjuntos",name:"Conjuntos"},
            {slug:"camisetas",name:"Camisetas"},
            {slug:"chaquetas-y-abrigos",name:"Chaquetas y abrigos"},
            {slug:"vaqueros",name:"Vaqueros"},
            {slug:"sudaderas",name:"Sudaderas"},
            {slug:"premama-y-bebes",name:"Premamá y bebés"},
            {slug:"ropa-premama",name:"Ropa premamá"},
            {slug:"sacaleches-eléctrico",name:"Sacaleches eléctrico"},
            {slug:"articulos-infantiles",name:"Artículos infantiles"},
            {slug:"juguetes",name:"Juguetes"},
            {slug:"juguetes-de-cabalgar",name:"Juguetes de cabalgar"},
            {slug:"exterior",name:"Exterior"},
            {slug:"figuras-de-accion",name:"Figuras de acción"},
            {slug:"bloques",name:"Bloques"},
            {slug:"juguetes-y-munecas",name:"Juguetes y muñecas"},
            {slug:"helicopteros-rc",name:"Helicópteros RC"},
            {slug:"peluches",name:"Peluches"},
            {slug:"coches-de-juguete",name:"Coches de juguete"},
            {slug:"bloques-de-construccion",name:"Bloques de construcción"},
            {slug:"maquetas",name:"Maquetas"},
            {slug:"pegatinas",name:"Pegatinas"},
            {slug:"peonzas",name:"Peonzas"},
            {slug:"peliculas-y-tv",name:"Películas y TV"},
            {slug:"alfombras-para-jugar",name:"Alfombras para jugar"},
            {slug:"sonajeros",name:"Sonajeros"},
            {slug:"juguetes-infantiles-en-general",name:"Juguetes infantiles en general"},

        ]
    },
    { 
        slug:"deporte-y-exterior",
        name:"Deporte y exterior",
        subcategories:[
            {slug:"deportes-acuaticos",name:"Deportes acuáticos"},
            {slug:"natacion",name:"Natación"},
            {slug:"traje-de-bano",name:"Traje de baño"},
            {slug:"conjunto-de-bano",name:"Conjunto de baño"},
            {slug:"vestidos-de-playa",name:"Vestidos de playa"},
            {slug:"banadores-de-hombre",name:"Bañadores de hombre"},
            {slug:"banadores-infantiles",name:"Bañadores infantiles"},
            {slug:"bicis-y-hoverboards",name:"Bicis y hoverboards"},
            {slug:"bicicletas",name:"Bicicletas"},
            {slug:"cuadros-de-bicicleta",name:"Cuadros de bicicleta"},
            {slug:"luces-de-bicicleta",name:"Luces de bicicleta"},
            {slug:"cascos-de-bicicleta",name:"Cascos de bicicleta"},
            {slug:"maillots-de-ciclismo",name:"Maillots de ciclismo"},
            {slug:"gafas-de-ciclismo",name:"Gafas de ciclismo"},
            {slug:"zapatillas",name:"Zapatillas"},
            {slug:"zapatillas-de-running",name:"Zapatillas de running"},
            {slug:"zapatillas-de-senderismo",name:"Zapatillas de senderismo"},
            {slug:"botas-de-futbol",name:"Botas de fútbol"},
            {slug:"zapatillas-de-skate",name:"Zapatillas de skate"},
            {slug:"zapatos-de-baile",name:"Zapatos de baile"},
            {slug:"zapatillas-de-baloncesto",name:"Zapatillas de baloncesto"},
            {slug:"pesca",name:"Pesca"},
            {slug:"carretes-de-pesca",name:"Carretes de pesca"},
            {slug:"cebos-de-pesca",name:"Cebos de pesca"},
            {slug:"hilo-de-pesca",name:"Hilo de pesca"},
            {slug:"canas-de-pescar",name:"Cañas de pescar"},
            {slug:"canas",name:"Cañas"},
            {slug:"cajas-de-pesca",name:"Cajas de pesca"},
            {slug:"moda-deportiva",name:"Moda deportiva"},
            {slug:"camisetas",name:"Camisetas"},
            {slug:"chaquetas-de-senderismo",name:"Chaquetas de senderismo"},
            {slug:"pantalones",name:"Pantalones"},
            {slug:"pantalones-cortos",name:"Pantalones cortos"},
            {slug:"bolsas-de-deporte",name:"Bolsas de deporte"},
            {slug:"accesorios-deportivos",name:"Accesorios deportivos"},
            {slug:"mas-material-deportivo",name:"Más material deportivo"},
            {slug:"camping-y-senderismo",name:"Camping y senderismo"},
            {slug:"caza",name:"Caza"},
            {slug:"golf",name:"Golf"},
            {slug:"fitness-y-bodybuilding",name:"Fitness y bodybuilding"},
            {slug:"esqui-y-snowboard",name:"Esquí y snowboard"},
            {slug:"instrumentos-musicales",name:"Instrumentos musicales"},
            {slug:"deportes-en-general",name:"Deportes en general"},
        ]
    },
    {   slug:"salud-belleza-y-peluquería",
        name:"Salud, belleza y peluquería",
        subcategories:[
            {slug:"extensiones",name:"Extensiones"},
            {slug:"extensiones-con-cierre",name:"Extensiones con cierre"},
            {slug:"extensiones-de-3-4",name:"Extensiones de 3/4"},
            {slug:"extensiones-de-colores",name:"Extensiones de colores"},
            {slug:"cierres",name:"Cierres"},
            {slug:"pelucas-de-encaje",name:"Pelucas de encaje"},
            {slug:"pelucas-de-encaje-frontal",name:"Pelucas de encaje frontal"},
            {slug:"pelucas-de-encaje",name:"Pelucas de encaje"},
            {slug:"pelucas-con-malla-completa",name:"Pelucas con malla completa"},
            {slug:"pelucas-250-de-densidad",name:"Pelucas 250% de densidad"},
            {slug: "pelo-sintetico",name:"Pelo sintético"},
            {slug: "pelucas-sinteticas",name:"Pelucas sintéticas"},
            {slug: "extensiones-sinteticas",name:"Extensiones sintéticas"},
            {slug: "trenzas",name:"Trenzas"},
            {slug: "extensiones-sinteticas",name:"Extensiones sintéticas"},
            {slug: "maquillaje",name:"Maquillaje"},
            {slug: "ojos",name:"Ojos"},
            {slug: "labios",name:"Labios"},
            {slug: "cara",name:"Cara"},
            {slug: "utensilios-de-maquillaje",name:"Utensilios de maquillaje"},
            {slug: "cuidado-de-la-salud",name:"Cuidado de la salud"},
            {slug: "masaje-y-relax",name:"Masaje y relax"},
            {slug: "monitorizacion-de-la-salud",name:"Monitorización de la salud"},
            {slug: "medicina-china",name:"Medicina china"},
            {slug: "cuidado-personal",name:"Cuidado personal"},
            {slug: "cuidado-de-la-piel",name:"Cuidado de la piel"},
            {slug: "cara",name:"Cara"},
            {slug: "ojos",name:"Ojos"},
            {slug: "cuerpo",name:"Cuerpo"},
            {slug: "utensilios-para-el-cuidado-de-la-piel",name:"Utensilios para el cuidado de la piel"},
            {slug: "manicura-y-pedicura",name:"Manicura y pedicura"},
            {slug: "esmalte-de-gel-para-unas",name:"Esmalte de gel para uñas"},
            {slug: "pulidoras-de-unas",name:"Pulidoras de uñas"},
            {slug: "lámparas-de-secado-para-unas",name:"Lámparas de secado para uñas"},
            {slug: "brillantina-para-unas",name:"Brillantina para uñas"},
            {slug: "cuidado-personal",name:"Cuidado personal"},
            {slug: "peluqueria",name:"Peluquería"},
            {slug: "afeitado-y-depilacion",name:"Afeitado y depilación"},
            {slug: "higiene-bucal",name:"Higiene bucal"},
            {slug: "tatuajes-y-body-art",name:"Tatuajes y body art"},
            {slug: "kits-de-tatuajes",name:"Kits de tatuajes"},
            {slug: "articulos-para-adultos",name:"Artículos para adultos"},
            {slug: "lubricantes",name:"Lubricantes"},
            {slug: "vibradores",name:"Vibradores"},
            {slug:"Salud-y-belleza-en-general",name:"Salud y belleza en general"},
        ]
    },
    { 
        slug:"motor",
        name:"Motor",
        subcategories:[
            {slug:"repuestos-para-coches",name:"Repuestos para coches"},
            {slug:"luces-para-coche",name:"Luces para coche"},
            {slug:"piezas-para-el-interior",name:"Piezas para el interior"},
            {slug:"piezas-para-el-exterior",name:"Piezas para el exterior"},
            {slug:"bujias-y-sistema-de-encendido",name:"Bujías y sistema de encendido"},
            {slug:"sensores-para-vehiculos",name:"Sensores para vehículos"},
            {slug:"sistema-de-frenos",name:"Sistema de frenos"},
            {slug:"limpiaparabrisas-y-ventanas",name:"Limpiaparabrisas y ventanas"},
            {slug:"mas-piezas-de-repuesto",name:"Más piezas de repuesto"},
            {slug:"herramientas-y-mantenimiento",name:"Herramientas y mantenimiento"},
            {slug:"lectores-y-escaneres-de-codigos",name:"Lectores y escáneres de códigos"},
            {slug:"herramientas-de-diagnostico",name:"Herramientas de diagnóstico"},
            {slug:"utensilios-de-limpieza",name:"Utensilios de limpieza"},
            {slug:"tratamiento-de-pintura",name:"Tratamiento de pintura"},
            {slug:"mas-articulos-de-mantenimiento",name:"Más artículos de mantenimiento"},
            {slug:"electronica-para-coche",name:"Electrónica para coche"},
            {slug:"reproductores-multimedia",name:"Reproductores multimedia"},
            {slug:"camaras-para-coche",name:"Cámaras para coche"},
            {slug:"sistemas-de-seguridad-y-alarmas",name:"Sistemas de seguridad y alarmas"},
            {slug:"localizadores-gps",name:"Localizadores GPS"},
            {slug:"radios",name:"Radios"},
            {slug:"monitores-para-coche",name:"Monitores para coche"},
            {slug:"refrigeradores-y-calentadores",name:"Refrigeradores y calentadores"},
            {slug:"camaras-para-coche",name:"Cámaras para coche"},
            {slug:"localizadores-gps-para-coches",name:"Localizadores GPS para coches"},
            {slug:"baterias-de-arranque",name:"Baterías de arranque"},
            {slug:"accesorios-para-el-exterior",name:"Accesorios para el exterior"},
            {slug:"pegatinas-para-coche",name:"Pegatinas para coche"},
            {slug:"cubiertas-para-coches",name:"Cubiertas para coches"},
            {slug:"mas-accesorios-para-exterior",name:"Más accesorios para exterior"},
            {slug:"piezas-y-accesorios-para-moto",name:"Piezas y accesorios para moto"},
            {slug:"piezas-para-la-estructura-de-la-moto",name:"Piezas para la estructura de la moto"},
            {slug:"cascos-y-proteccion",name:"Cascos y protección"},
            {slug:"iluminacion",name:"Iluminación"},
            {slug:"sistemas-de-frenado",name:"Sistemas de frenado"},
            {slug:"sistemas-de-escape",name:"Sistemas de escape"},
            {slug:"cascos",name:"Cascos"},
            {slug:"cubiertas-de-asientos-para-motos",name:"Cubiertas de asientos para motos"},
            {slug:"mas-accesorios-para-moto",name:"Más accesorios para moto"},
            {slug:"accesorios-para-el-interior",name:"Accesorios para el interior"},
            {slug:"cubiertas-para-asientos",name:"Cubiertas para asientos"},
            {slug:"almacenamiento",name:"Almacenamiento"},
            {slug:"llaveros",name:"Llaveros"},
            {slug:"fundas-para-volantes",name:"Fundas para volantes"},
            {slug:"alfombrillas",name:"Alfombrillas"},
            {slug:"mortores-en-general",name:"Motores en general"},
        ]
    },
    { 
        slug:"herramientas-y-bricolaje",
        name:"Herramientas y briocolaje",
        subcategories:[
            {slug:"herramientas-de-medicion-y-analisis",name:"Herramientas de medición y análisis"},
            {slug:"herramientas-manuales",name:"Herramientas manuales"},
            {slug:"herramientas-electricas",name:"Herramientas eléctricas"},
            {slug:"herramientas-de-jardineria",name:"Herramientas de jardinería"},
            {slug:"juegos-de-herramientas",name:"Juegos de herramientas"},
            {slug:"iluminacion-interior",name:"Iluminación interior"},
            {slug:"luces-de-techo",name:"Luces de techo"},
            {slug:"lamparas-colgantes",name:"Lámparas colgantes"},
            {slug:"luces-empotradas",name:"Luces empotradas"},
            {slug:"candelabros",name:"Candelabros"},
            {slug:"lamparas-de-pared",name:"Lámparas de pared"},
            {slug:"lamparas-de-noche",name:"Lámparas de noche"},
            {slug:"herramientas",name:"Herramientas"},
            {slug:"equipos-para-soldar",name:"Equipos para soldar"},
            {slug:"utensilios-para-soldar",name:"Utensilios para soldar"},
            {slug:"herramientas-y-accesorios-para-maquinas",name:"Herramientas y accesorios para máquinas"},
            {slug:"carpinteria",name:"Carpintería"},
            {slug:"almacenamiento",name:"Almacenamiento"},
            {slug:"iluminacion-led",name:"Iluminación LED"},
            {slug:"tiras-led",name:"Tiras LED"},
            {slug:"luces-led-empotrables",name:"Luces LED empotrables"},
            {slug:"panel-de-luces-led",name:"Panel de luces LED"},
            {slug:"focos-led",name:"Focos LED"},
            {slug:"barras-led",name:"Barras LED"},
            {slug:"bricolaje",name:"Bricolaje"},
            {slug:"accesorios-y-equipos-electricos",name:"Accesorios y equipos eléctricos"},
            {slug:"interruptores-de-pared",name:"Interruptores de pared"},
            {slug:"ferreteria",name:"Ferretería"},
            {slug:"accesorios-para-cocinas",name:"Accesorios para cocinas"},
            {slug:"herramientas-de-pintura",name:"Herramientas de pintura"},
            {slug:"equipos-de-bombeo",name:"Equipos de bombeo"},
            {slug:"iluminacion-de-exterior",name:"Iluminación de exterior"},
            {slug:"linternas",name:"Linternas"},
            {slug:"lamparas-solares",name:"Lámparas solares"},
            {slug:"focos",name:"Focos"},
            {slug:"cadenas-de-luces",name:"Cadenas de luces"},
            {slug:"iluminacion-sumergible",name:"Iluminación sumergible"},
        ]
    },
    {
        name:"Restaurante",
        slug:"restaurante",
        subcategories:[
            {slug:"barra-de-ensalada",name:"Barra de Ensalada"},
            {slug:"batidos",name:"Batidos"},
            {slug:"cafe",name:"Café"},
            {slug:"carnes",name:"Carnes"},
            {slug:"ceviche",name:"Ceviche"},
            {slug:"comida-arabe",name:"Comida Árabe"},
            {slug:"comida-armenia",name:"Comida Armenia"},
            {slug:"comida-asiatica",name:"Comida Asiática"},
            {slug:"comida-china",name:"Comida China"},
            {slug:"comida-congelada",name:"Comida Congelada"},
            {slug:"comida-india",name:"Comida India"},
            {slug:"comida-italiana",name:"Comida Italiana"},
            {slug:"comida-japonesa",name:"Comida Japonesa"},
            {slug:"comida-mexicana",name:"Comida Mexicana"},
            {slug:"comida-peruana",name:"Comida Peruana"},
            {slug:"comida-rapida",name:"Comida Rápida"},
            {slug:"comida-vegana",name:"Comida Vegana"},
            {slug:"comida-vegetariana",name:"Comida Vegetariana"},
            {slug:"comida-venezolana",name:"Comida Venezolana"},
            {slug:"desayuno",name:"Desayuno"},
            {slug:"empanadas",name:"Empanadas"},
            {slug:"saltenas",name:"Salteñas"},
            {slug:"ensaladas",name:"Ensaladas"},
            {slug:"hamburguesas",name:"Hamburguesas"},
            {slug:"internacional",name:"Internacional"},
            {slug:"nacional",name:"Nacional"},
            {slug:"mariscos",name:"Mariscos"},
            {slug:"panaderia",name:"Panadería"},
            {slug:"parrilla",name:"Parrilla"},
            {slug:"pasta",name:"Pasta"},
            {slug:"pizza",name:"Pizza"},
            {slug:"poke",name:"Poke"},
            {slug:"pollo",name:"Pollo"},
            {slug:"postres",name:"Postres"},
            {slug:"Sandwiches",name:"Sandwiches"},
            {slug:"shakes",name:"Shakes"},
            {slug:"sopas",name:"Sopas"},
            {slug:"sushi",name:"Sushi"},
            {slug:"tortilla",name:"Tortilla"},
            {slug:"todo-tipo-de-comida-en-general",name:"Todo tipo de comida en general"},
    
        ]
        
    },
    {
        name:"Bebidas",
        slug:"bebidas",
        subcategories:[
            {slug:"cocoroco",name:"Cocoroco"},
            {slug:"vodka-pirytus",name:"Vodka Spirytus"},
            {slug:"absenta",name:"Absenta"},
            {slug:"chinchon-seco especial",name:"Chinchón seco especial"},
            {slug:"licor-de-cocuy",name:"Licor de cocuy"},
            {slug:"bacanora",name:"Bacanora"},
            {slug:"mezcal",name:"Mezcal"},
            {slug:"whisky",name:"Whisky"},
            {slug:"orujo-blanco",name:"Orujo blanco"},
            {slug:"fernet",name:"Fernet"},
            {slug:"conac",name:"Coñac"},
            {slug:"cachaza",name:"Cachaza"},
            {slug:"grappa",name:"Grappa"},
            {slug:"aquavit",name:"Aquavit"},
            {slug:"becherovka",name:"Becherovka"},
            {slug:"gin-de-menorca",name:"Gin de Menorca"},
            {slug:"vodka",name:"Vodka"},
            {slug:"ron",name:"Ron"},
            {slug:"tequila",name:"Tequila"},
            {slug:"ouzo",name:"Ouzo"},
            {slug:"bourbon",name:"Bourbon"},
            {slug:"brandy",name:"Brandy"},
            {slug:"ginebra",name:"Ginebra"},
            {slug:"chinchón",name:"Chinchón"},
            {slug:"jagermeister",name:"Jägermeister"},
            {slug:"cana",name:"Caña"},
            {slug:"pisco",name:"Pisco"},
            {slug:"aguardiente",name:"Aguardiente"},
            {slug:"palo",name:"Palo"},
            {slug:"tia-maria",name:"Tía María"},
            {slug:"limoncello",name:"Limoncello"},
            {slug:"punsch",name:"Punsch"},
            {slug:"cherry-heering",name:"Cherry Heering"},
            {slug:"pacharan",name:"Pacharán"},
            {slug:"ratafia",name:"Ratafia"},
            {slug:"vino-de-oporto",name:"Vino de Oporto"},
            {slug:"vodka-azul-o-rojo",name:"Vodka Azul o Rojo"},
            {slug:"vino-de-arroz",name:"Vino de arroz"},
            {slug:"vermut",name:"Vermut"},
            {slug:"jerez",name:"Jerez"},
            {slug:"mariete",name:"Mariete"},
            {slug:"vino",name:"Vino"},
            {slug:"pelin",name:"Pelin"},
            {slug:"pulque",name:"Pulque"},
            {slug:"cerveza",name:"Cerveza"},
            {slug:"chinchon-conga",name:"Chinchón conga"},
            {slug:"sidra",name:"Sidra"},
            {slug:"bebidas-en-general",name:"Bebidas en general"},
        ]
    }
];


export default productsCategoriesAndSubcategories;